import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import ExperiencesApi from "../services/ExperiencesAPI";

const ExperiencesContext = createContext();

export const useExperiences = () => useContext(ExperiencesContext);

export const ExperiencesProvider = ({ children }) => {
  const { organizationId } = useAuth();

  const [experiences, setExperiences] = useState(null);
  const [guides, setGuides] = useState(null);
  const [insights, setInsights] = useState(null);
  const [assessments, setAssessments] = useState(null);

  useEffect(() => {
    if (organizationId) {
      fetchData();
    }
    else{
      console.log("No organization found")
    }
  }, [organizationId]);

   const fetchExperiences = () =>
     ExperiencesApi.get(`experiences?organization=${organizationId}`, { requiresAuth: true })
       .then((res) => setExperiences(res?.data || []))
       .catch((err) => console.error("Error fetching experiences:", err));

   const fetchGuides = () =>
     ExperiencesApi.get(`guides?organization=${organizationId}`, { requiresAuth: true })
       .then((res) => setGuides(res?.data || []))
       .catch((err) => console.error("Error fetching guides:", err));

   const fetchInsights = () =>
     ExperiencesApi.get(`insights?organization=${organizationId}`, { requiresAuth: true })
       .then((res) => setInsights(res?.data || []))
       .catch((err) => console.error("Error fetching insights:", err));

   const fetchAssessments = () =>
     ExperiencesApi.get(`assessments?organization=${organizationId}`, { requiresAuth: true })
       .then((res) => setAssessments(res?.data || []))
       .catch((err) => console.error("Error fetching assessments:", err));

   const fetchData = () => {
     console.log("Fetching experiences data for organization:", organizationId);
     fetchExperiences();
     fetchGuides();
     fetchInsights();
     fetchAssessments();
   };

   const postGuide = async (guidePayload) => {
     if (!guidePayload?.id) throw new Error("postGuide requires a guide with an id");

     try {
       await ExperiencesApi.post("guides", { ...guidePayload }, { requiresAuth: true });
      //  await fetchGuides(); // refresh only the guides after successful POST
     } catch (err) {
       console.error("Error posting guide:", err);
       throw err;
     }
   };

   

  const extractGuideId = (g) => (g?.sk || "").split("GUIDE#")[1];

  const deleteGuide = async (guideId) => {
    if (!guideId) return;

    // optimistic remove
    setGuides((prev) => (Array.isArray(prev) ? prev.filter((g) => extractGuideId(g) !== guideId) : prev));

    try {
      // GET delete route (HTTP API constraint)
      await ExperiencesApi.get(`guides/${guideId}/delete`, { requiresAuth: true });

      // optional safety refetch (comment out if not needed)
      await fetchGuides();
    } catch (err) {
      console.error("Delete failed, rolling back via refetch:", err);
      await fetchGuides(); // rollback by reloading server truth
      throw err;
    }
  };

  const value = {
    experiences,
    guides,
    insights,
    assessments,
    fetchData,
    fetchGuides,
    deleteGuide,
    postGuide
  };

  return (
    <ExperiencesContext.Provider value={value}>
      {children}
    </ExperiencesContext.Provider>
  );
};
